export const validationText = {
  error: {
    enter_email: 'Please enter an email',
    enter_valid_email: 'Please enter a valid email address',
  },
};
export const getQueryString = (params) => {
  const searchParams = new URLSearchParams();
  for (const key in params) {
    if (params.hasOwnProperty(key)) {
      searchParams.append(key, params[key]);
    }
  }
  return searchParams.toString();
};


export function withTryCatch(fn) {
  return async (...args) => {
    try {
      return await fn(...args);
    } catch (error) {
      // Handle the error here or re-throw it if needed
      console.error("An error occurred:", error);
    }
  };
}

// // Example usage:
// const myFunction = async () => {
//   // Code that might throw an error
//   throw new Error("This is a test error");
// };

// const myFunctionWithTryCatch = withTryCatch(myFunction);

// // Now, you can call myFunctionWithTryCatch, and it will be wrapped in a try-catch block
// myFunctionWithTryCatch();
